export default {
  'hero.hotTag': '🔥 实时热点',
  'hero.line1': '独家猛料',
  'hero.line2': '每日追踪',
  'hero.line3': '吃瓜不停',
  'hero.subtitle': '覆盖911爆料网、51爆料网、91爆料网等核心爆料入口，为您呈现娱乐圈最劲爆的内幕与网红最新塌房现场。',
  'hero.viewMore': '查看更多爆料',
  'hero.latest': '最新',
  'categories.title': '全网频道',
  'categories.heading': '六大爆料入口',
  'categories.subtitle': '全方位覆盖娱乐圈、网红圈最热门爆料话题',
  'articles.title': '最新爆料',
  'articles.subtitle': '每日更新 · 实时追踪 · 独家深度',
  'articles.readMore': '查看详情',
  'articles.views': '次阅读',
  'articles.comments': '条评论',
  'hot.title': '本周最热',
  'hot.heading': '吃瓜群众都在',
  'hot.headingLight': '看什么？',
  'hot.description': '这些是最受吃瓜群众关注的热门爆料。每一个都是引爆社交平台的现象级话题，从明星婚姻内幕到网红翻车实录，从娱乐圈潜规则到直播带货骗局——你想知道的猛料，这里全都有。',
  'hot.author': '爆料网数据',
  'hot.more': '查看全部热门',
  'hot.rank': '热度排行',
  'brand.tag': '关于我们',
  'brand.heading': '十年深耕 娱乐圈第一手内幕 尽在爆料网',
  'brand.joinUs': '加入我们',
  'brand.learnMore': '了解更多',
  'cta.title': '不错过任何',
  'cta.titleEmphasis': '重磅爆料',
  'cta.subtitle': '每一次塌房现场都有我们',
  'cta.button': '立即订阅每日爆料',
  'cta.trust': '已有超过 500 万吃瓜群众加入',
};